import { render, staticRenderFns } from "./WorldHeadbar.vue?vue&type=template&id=cc39a604&scoped=true&"
import script from "./WorldHeadbar.vue?vue&type=script&lang=js&"
export * from "./WorldHeadbar.vue?vue&type=script&lang=js&"
import style0 from "./WorldHeadbar.vue?vue&type=style&index=0&id=cc39a604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc39a604",
  null
  
)

export default component.exports